import { render, staticRenderFns } from "./ExamCard.vue?vue&type=template&id=c2c4fa7c&scoped=true&"
import script from "./ExamCard.vue?vue&type=script&lang=ts&"
export * from "./ExamCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExamCard.vue?vue&type=style&index=0&id=c2c4fa7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c4fa7c",
  null
  
)

export default component.exports